import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import FetchSchedule from 'pages/app/shifts/partials/FetchSchedule'
import ConstrainedScheduleSlotsCollection from 'widgets/shifts/ConstrainedScheduleSlotsCollection'
import List from 'widgets/shifts/themes/list/List'
import * as UI from 'ui'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import * as Icons from 'ui/icons'
import ManageShiftExchangesSmartview from './partials/smartviews/ManageShiftExchangesSmartview'
import { Translation } from '@morningtrain/react-translations'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'

export default function ShiftExchangeOverview () {
  return (
    <AdminPageWithSmartview slideInSmartview>
      <FetchSchedule
        actions={(
          <Can permission={Permissions.SHIFTS_EXCHANGE_MANAGE}>
            <MountSmartviewOnClick smartview={<ManageShiftExchangesSmartview />} replace={false}>
              <UI.Button color='primary'>
                <UI.WithIcon icon={<Icons.Settings className='w-5 h-5' />} placement='right'>
                  <Translation name='shiftexchange.actions.manage_approvals' />
                </UI.WithIcon>
              </UI.Button>
            </MountSmartviewOnClick>
          </Can>
        )}
        titleTransName='shiftexchange.title'
      >
        <ConstrainedScheduleSlotsCollection operationName='grouped_by_day_with_exchange'>
          <List />
        </ConstrainedScheduleSlotsCollection>
      </FetchSchedule>
    </AdminPageWithSmartview>
  )
}
